import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { EntityUIQuery, QueryEntity } from '@datorama/akita';

import {
  ForecastSettingsState,
  ForecastSettingsStore,
  ForecastSettingsUIState,
} from './forecast-settings.store';

@Injectable({ providedIn: 'root' })
export class ForecastSettingsQuery extends QueryEntity<ForecastSettingsState> {
  settings = toSignal(this.selectAll(), { requireSync: true });

  protected store: ForecastSettingsStore;
  ui!: EntityUIQuery<ForecastSettingsUIState>;

  constructor() {
    const store = inject(ForecastSettingsStore);

    super(store);
    this.store = store;

    this.createUIQuery();
  }
}
